import { useState, useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';

// Stylesheets & Fonts
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'typeface-poppins';
// Components
import ScrollToTop from './components/ScrollToTop';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import LogoTicker from './components/LogoTicker';
import Portfolio from './components/Portfolio';
import Ticker from './components/Ticker';
import Skills from './components/Skills';
import PassionProjects from './components/PassionProjects';
import Highlights from './components/Highlights';
import MyExperience from './components/MyExperience';
import RecentPosts from './components/RecentPosts';
import Footer from './components/Footer';
import LockedItems from './components/LockedItems';
import PortfolioShowcase from './components/PortfolioShowcase';
import MyProcess from './components/MyProcess';
// Coming Soon Page
import ComingSoon from './components/ComingSoon';
// About
import About from './components/About';
// Portfolio
import PortfolioDetail from './components/PortfolioDetail';
// Assets
import logo from './images/michelle-maltbia-logo.svg';
import contactPlaceholder from './images/contact-button.svg';
import ContactButton from './components/AnimationContactButton'
import AnimationContactButton from './components/AnimationContactButton';
//Blog
import Blog from "./pages/StrapiBlog";
import Article from "./pages/Article";
import TagArticles from "./pages/TagArticles";


function App() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // State for the drawer

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev); // Toggle the drawer state
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [showArrows, setShowArrows] = useState(false);
  const [activeProject, setActiveProject] = useState(null);
  const carouselRef = useRef(null);

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 612; // Width of one portfolio item + gap
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const updatePageIndicator = () => {
    if (carouselRef.current) {
      const scrollLeft = carouselRef.current.scrollLeft;
      const pageWidth = 428; // Width of one portfolio item + gap
      const currentPage = Math.round(scrollLeft / pageWidth);
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener('scroll', updatePageIndicator);
      return () => carousel.removeEventListener('scroll', updatePageIndicator);
    }
  }, []);

  const portfolioRef = useRef(null);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation
          logo={logo}
          contactPlaceholder={contactPlaceholder}
          toggleDrawer={toggleDrawer}
          isDrawerOpen={isDrawerOpen}
        />
        <Routes>
          {/* Home Route */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <LogoTicker />
                <Portfolio
                  carouselRef={carouselRef}
                  scrollCarousel={scrollCarousel}
                  activeProject={activeProject}
                  setActiveProject={setActiveProject}
                />
                <Highlights project={activeProject} />
                <Skills />
                <RecentPosts />
                {/* <Ticker text="passion projects" /> */}
                <PassionProjects />
                <MyExperience />
              </>
            }
          />
          {/* Portfolio Detail Page */}
          <Route path="/portfolio/:id" element={<PortfolioDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/recent-thoughts" element={<Blog />} />
          <Route path="/recent-thoughts/:slug" element={<Article />} />
          <Route path="/tags/:tag" element={<TagArticles />} />
          {/* <Route path="/my-process" element={<MyProcess />} /> */}
          <Route path="/portfolio/locked" element={<LockedItems />} />
          <Route path="/portfolio" element={<PortfolioShowcase />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}



export default App;
